/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions  */
import React, { useContext } from 'react';

import Calendar from '@digital-hig/icon/icons/calendar';
import SvgIcon from '@digital-hig/mui/SvgIcon';
import Typography from '@digital-hig/mui/Typography';

import I18nContext from '../../contexts/I18nContext';

interface AddToCalendarUIProps {
  title: string;
  description?: string;
  epochStart: number;
  length: number;
  location?: string;
  onClick?: () => void;
}

function AddToCalendarUI({
  title,
  description,
  epochStart,
  length,
  location,
  onClick,
}: AddToCalendarUIProps) {
  const { t } = useContext(I18nContext);

  const startTimeDate = new Date(0);
  startTimeDate.setUTCSeconds(epochStart);
  const startTime = startTimeDate.toISOString().replace(/-|:|\.\d{3}/g, '');
  const endTime = new Date(startTimeDate.getTime() + length * 60 * 1000)
    .toISOString()
    .replace(/-|:|\.\d{3}/g, '');

  const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${Date.now()}@autodesk.com
SUMMARY:${title}
DESCRIPTION:${description || ''}
DTSTART:${startTime}
DTEND:${endTime}
LOCATION:${location || ''}
END:VEVENT
END:VCALENDAR`;

  const downloadICS = () => {
    const blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${title.replace(/\s+/g, '_')}.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleCalendarClick = () => {
    if (onClick) {
      onClick();
    }
    downloadICS();
  };

  return (
    <div
      onClick={handleCalendarClick}
      style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
    >
      <SvgIcon fontSize="small">
        <Calendar />
      </SvgIcon>
      &nbsp;
      <Typography
        sx={{
          marginLeft: 10,
          fontSize: 16,
          fontWeight: 400,
          color: '#5f60ff',
        }}
      >
        {t('addToCalendar')}
      </Typography>
    </div>
  );
}

export default AddToCalendarUI;
